import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IMAGE_URL } from "../../api-urls";
import icons from "../../icons.config";

const TrendWavesSection = ({
  getVisibleItems,
  visibleItems,
  isFading,
  handleNext,
  handlePrev,
  handleDotClick,
  currentIndex,
  numberOfDots,
  handlers,
  handleItemClick,
  handleHeartClick,
  likedItems,
  isAuthenticated,
}) => (
  <section className="flex flex-col justify-center items-center w-full h-full bg-tertiary relative pb-10 space-y-5 -mt-36">
    <h1 className="text-primary1 font-poppins text-3xl lg:py-14 font-extralight mb-2 relative bottom-2">
      TREND WAVES
    </h1>

    <div className="relative w-full max-w-7xl h-full bottom-2" {...handlers}>
      <img
        src={icons.arrowLeft}
        alt="left arrow"
        className="absolute lg:left-20 xl:left-11 2xl:-left-1 top-[45%] transform -translate-y-1/2 text-primary1 text-lg font-semibold w-8 h-8 rounded-[50%] z-20 bg-secondary hidden lg:block cursor-pointer"
        onClick={handlePrev}
      />

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10 lg:gap-6 px-11 md:px-11 lg:px-20 xl:px-14 2xl:px-3">
        {getVisibleItems().slice(0, visibleItems).map((item) => (
          <div key={item.id} className="text-left flex justify-center relative z-10">
            <AnimatePresence mode="wait">
              <motion.div
                key={item.id}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ duration: 0.5 }}
                className={`${
                  isFading ? "opacity-0" : "opacity-100"
                } cursor-pointer w-full h-60 md:h-96 md:w-[98%] xl:h-screen relative xl:pb-36 2xl:pb-32 justify-center items-center aspect-[3/4]`}
              >
                <motion.div
                  className="overflow-hidden h-full"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                  onClick={() => handleItemClick(item)}
                >
                  <motion.img
                    src={
                      item.default_variant?.images?.length > 0
                        ? IMAGE_URL + item.default_variant.images[0]
                        : ""
                    }
                    alt={item.product_name || "Product Thumbnail"}
                    className="w-full h-full object-cover transition-all duration-500"
                  />
                </motion.div>

                <div
                  className="absolute top-4 right-4 font-light cursor-pointer"
                  onClick={() => handleHeartClick(item)}
                >
                  <img
                    src={
                      isAuthenticated &&
                      likedItems.some(
                        (likedItem) =>
                          likedItem?.variant_id?.toString() ===
                          item?.default_variant?.id?.toString()
                      )
                        ? icons.filledHeart
                        : icons.heart
                    }
                    alt="Heart Icon"
                    className="w-5 h-5 md:w-7 md:h-7"
                  />
                </div>

                {item.product_name && (
                  <motion.h2
                    className="font-light mt-2 font-outfit text-md lg:text-lg text-primary1"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1.5 }}
                  >
                    {item.product_name}
                  </motion.h2>
                )}

                <motion.p
                  className="text-sm mt-1 text-hcolor font-poppins font-light"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1.5 }}
                >
                  {item.default_variant.discount_price
                    ? `Rs. ${item.default_variant.discount_price} INR`
                    : "Price Not Available"}
                </motion.p>
              </motion.div>
            </AnimatePresence>
          </div>
        ))}
      </div>

      <img
        src={icons.arrowRight}
        alt="right arrow"
        className="absolute top-[45%] lg:right-20 xl:right-10 2xl:-right-2 transform -translate-y-1/2 hidden text-primary1 rounded-[50%] bg-secondary lg:block w-8 h-8 z-10 cursor-pointer"
        onClick={handleNext}
      />
    </div>

    <div className="flex justify-center relative -bottom-2 z-10 lg:hidden pt-12 pb-5">
      {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
        <button
          key={dotIndex}
          onClick={() => handleDotClick(dotIndex)}
          className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full 
            ${
              dotIndex === Math.floor(currentIndex / visibleItems)
                ? "bg-hcolor"
                : "bg-white border border-hcolor"
            } shadow-lg`}
        />
      ))}
    </div>

    <div className="lg:hidden z-30">
      <div className="absolute left-6 -bottom-5">
        <img src={icons.collectionMFlower} alt="Doodle Right" className="w-12 md:w-full" />
      </div>
    </div>
  </section>
);

export default TrendWavesSection;